export const getMiddleValue = (arr = []) => arr[Math.floor(arr.length / 2)];
